module.exports = __webpack_public_path__ + "static/media/profile_photo_2.3b0be533.jpg";